import * as React from 'react'
import { BPMChart } from '../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../api'
import { Series, Legend } from 'devextreme-react/chart'
import { resultDateTransformer } from '../../../utils/date'

export const MembershipChart: React.FunctionComponent<{ type: 'membership' | 'one-time-purchases' }> = ({ type }) => {
    const [total, setTotal] = React.useState(0)
    return (
        <BPMChart title={type == 'membership' ? 'Memberships' : 'Purchases'} type='doughnut' subTitle={`Total of ${total} ${type == 'membership' ? 'memberships' : 'purchases'}`}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>(type + '/distribution', { ...options }, signal)).then((d) => {
                    setTotal(d.reduce((a, b) => a + b.count, 0))
                    return d
                })
            }} additionalParams={{ groupBy: 'membership' }}>
            <Series
                valueField="count"
                argumentField="membership">
            </Series>
            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/charts/MembershipChart.tsx